// eslint-disable-next-line import/no-anonymous-default-export
export default {
  dashboard: 'Dashboard',
  dashboardDesc: 'Ana sayfa - Genel istatistikler ve özet bilgiler',
  customers: 'Müşteriler',
  customersDesc: 'Müşteri yönetimi - Müşteri bilgileri ve iletişim detayları',
  domains: 'Domainler',
  domainsDesc: 'Domain yönetimi - Domain takibi, yenileme ve kayıt bilgileri',
  servers: 'Sunucular',
  serversDesc: 'Sunucu yönetimi - Hosting sunucuları, IP adresleri ve durumları',
  companies: 'Şirketler',
  companiesDesc: 'Firma bilgileri - Müşteri şirket bilgileri ve yönetimi',
  users: 'Kullanıcılar',
  usersDesc: 'Kullanıcı yönetimi - Sistem kullanıcıları ve yetki ayarları',
  settings: 'Ayarlar',
  settingsDesc: 'Sistem ayarları - Genel ayarlar ve yapılandırma',
  domainPrices: 'Domain Fiyatları',
  domainPricesDesc: 'Domain fiyatları - Domain uzantı fiyat tanımlamaları',
  hostingPrices: 'Hosting Fiyatları',
  hostingPricesDesc: 'Hosting fiyatları - Hosting paket fiyatları ve özellikleri',
  pricing: 'Fiyatlandırma',
  registrars: 'Domain Firmaları',
  registrarsDesc: 'Kayıt firmaları - Domain registrar bilgileri ve API ayarları',
  panels: 'Paneller',
  calendar: 'Takvim',
  calendarDesc: 'Takvim - Ödeme tarihleri, alacaklar ve borçlar takvimi',
  maps: 'Haritalar',
  mapsDesc: 'Harita görünümü - Şirketlerin coğrafi dağılımı ve harita analizi',
  dataManagement: 'Veri Yönetimi',
  dataManagementDesc: 'Veri yönetimi - Export/Import işlemleri ve veri yedekleme',
  languages: 'Diller',
  analyses: 'Analizler',
  analysesDesc: 'Ödeme ve gelir analizleri - Detaylı raporlar ve grafikler',
  paymentAnalysis: 'Ödeme Analizi',
  paymentAnalysisDesc: 'Ödeme analizi - Müşteri ödemeleri, gelirler ve istatistikler',
  accountTracking: 'Cari Takip',
  accountTrackingDesc: 'Cari hesap takibi - Alacaklar, borçlar ve para birimi yönetimi',
  recurringPayments: 'Tekrarlı Ödemeler',
  recurringPaymentsDesc: 'Tekrarlı ödemeler - Aylık/yıllık abonelik ödemeleri yönetimi',
  financialTransactions: 'Finansal İşlemler',
  financialTransactionsDesc: 'Finansal işlemler - Cari takip, tekrarlı ödemeler ve takvim',
  system: 'Sistem'
};
